import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/app/environments/environment';


export interface PlatformStats {
  totalCompanies:     number;
  totalWorkers:       number;
  totalAdmins:        number;
  totalJobs:          number;
  totalLogs:          number;
  totalHours:         number;
  companiesThisMonth: number;
}

export interface CompanySummary {
  id:          string;
  name:        string;
  createdUtc:  string;
  workerCount: number;
  adminCount:  number;
  jobCount:    number;
  logCount:    number;
  isActive:    boolean;
}

export interface CompanyDetail {
  id:         string;
  name:       string;
  createdUtc: string;
  workers:    { id: string; fullName: string; email: string; isActive: boolean }[];
  admins:     { id: string; fullName: string; email: string; isActive: boolean }[];
  jobs:       { id: string; title: string; status: number; createdUtc: string }[];
  recentLogs: { id: string; userId: string; hoursSpent: number; createdUtc: string }[];
}

export interface SuperAdminWorker {
  id:          string;
  fullName:    string;
  email:       string;
  isActive:    boolean;
  companyId:   string;
  companyName: string;
  logCount:    number;
}

export interface SuperAdminJob {
  id:           string;
  title:        string;
  locationName: string;
  status:       number;
  createdUtc:   string;
  companyId:    string;
  companyName:  string;
  logCount:     number;
}

@Injectable({ providedIn: 'root' })
export class SuperAdminService {

  private base = `${environment.apiUrl}/api/superadmin`;

  constructor(private http: HttpClient) {}

  getStats(): Observable<PlatformStats> {
    return this.http.get<PlatformStats>(`${this.base}/stats`);
  }

  getCompanies(): Observable<CompanySummary[]> {
    return this.http.get<CompanySummary[]>(`${this.base}/companies`);
  }

  getCompany(id: string): Observable<CompanyDetail> {
    return this.http.get<CompanyDetail>(`${this.base}/companies/${id}`);
  }

  getAllWorkers(): Observable<SuperAdminWorker[]> {
    return this.http.get<SuperAdminWorker[]>(`${this.base}/workers`);
  }

  getAllJobs(): Observable<SuperAdminJob[]> {
    return this.http.get<SuperAdminJob[]>(`${this.base}/jobs`);
  }

  suspendCompany(id: string): Observable<any> {
    return this.http.patch(`${this.base}/companies/${id}/suspend`, {});
  }

  reactivateCompany(id: string): Observable<any> {
    return this.http.patch(`${this.base}/companies/${id}/reactivate`, {});
  }
}